import { Phone, Calendar, MessageCircle } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { contact } from "@/lib/healic-data";

export function FloatingActions() {
  const whatsappLink = `https://wa.me/${contact.whatsapp}?text=${encodeURIComponent("Hi Healic, I would like to know more about your services.")}`;

  return (
    <div className="fixed right-3 bottom-4 z-50 flex flex-row gap-2 sm:right-4 sm:top-1/2 sm:bottom-auto sm:flex-col sm:gap-3 sm:-translate-y-1/2">
      <a
        href={`tel:${contact.phoneTel}`}
        aria-label="Call us"
        className="grid h-11 w-11 place-items-center rounded-full bg-primary text-primary-foreground shadow-soft transition-transform hover:scale-110 hover:shadow-card sm:h-12 sm:w-12"
      >
        <Phone className="h-5 w-5" />
      </a>
      <Link
        to="/contact"
        aria-label="Book an appointment"
        className="grid h-11 w-11 place-items-center rounded-full bg-accent text-accent-foreground shadow-soft transition-transform hover:scale-110 hover:shadow-card sm:h-12 sm:w-12"
      >
        <Calendar className="h-5 w-5" />
      </Link>
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="grid h-11 w-11 place-items-center rounded-full bg-whatsapp text-primary-foreground shadow-soft transition-transform hover:scale-110 hover:shadow-card sm:h-12 sm:w-12"
      >
        <MessageCircle className="h-5 w-5" />
      </a>
    </div>
  );
}
